/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilterItemDto } from './FilterItemDto';
import {
    FilterItemDtoFromJSON,
    FilterItemDtoFromJSONTyped,
    FilterItemDtoToJSON,
    FilterItemDtoToJSONTyped,
} from './FilterItemDto';

/**
 * 
 * @export
 * @interface GetQuoteFilterResponseDto
 */
export interface GetQuoteFilterResponseDto {
    /**
     * 
     * @type {Array<FilterItemDto>}
     * @memberof GetQuoteFilterResponseDto
     */
    products: Array<FilterItemDto>;
    /**
     * 
     * @type {Array<FilterItemDto>}
     * @memberof GetQuoteFilterResponseDto
     */
    owners: Array<FilterItemDto>;
    /**
     * 
     * @type {Array<FilterItemDto>}
     * @memberof GetQuoteFilterResponseDto
     */
    statuses: Array<FilterItemDto>;
}

/**
 * Check if a given object implements the GetQuoteFilterResponseDto interface.
 */
export function instanceOfGetQuoteFilterResponseDto(value: object): value is GetQuoteFilterResponseDto {
    if (!('products' in value) || value['products'] === undefined) return false;
    if (!('owners' in value) || value['owners'] === undefined) return false;
    if (!('statuses' in value) || value['statuses'] === undefined) return false;
    return true;
}

export function GetQuoteFilterResponseDtoFromJSON(json: any): GetQuoteFilterResponseDto {
    return GetQuoteFilterResponseDtoFromJSONTyped(json, false);
}

export function GetQuoteFilterResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuoteFilterResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'products': ((json['products'] as Array<any>).map(FilterItemDtoFromJSON)),
        'owners': ((json['owners'] as Array<any>).map(FilterItemDtoFromJSON)),
        'statuses': ((json['statuses'] as Array<any>).map(FilterItemDtoFromJSON)),
    };
}

export function GetQuoteFilterResponseDtoToJSON(json: any): GetQuoteFilterResponseDto {
    return GetQuoteFilterResponseDtoToJSONTyped(json, false);
}

export function GetQuoteFilterResponseDtoToJSONTyped(value?: GetQuoteFilterResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'products': ((value['products'] as Array<any>).map(FilterItemDtoToJSON)),
        'owners': ((value['owners'] as Array<any>).map(FilterItemDtoToJSON)),
        'statuses': ((value['statuses'] as Array<any>).map(FilterItemDtoToJSON)),
    };
}

